/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#map[_ngcontent-%COMP%]{width:100%;height:500px;margin-bottom:36px}.state-wrapper[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:5px;padding:8px;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center}.main-container[_ngcontent-%COMP%]{margin-top:16px;padding:10px;text-align:right}"];
export { styles as styles };
